import options from './content-header.component';

export default {
    selector: 'dtContentHeader',
    options
};



// WEBPACK FOOTER //
// ./app/common/content-header/index.js